import { KeyboardEvent, MouseEvent } from 'react';

export function selfClickOnEnterOrSpace<E extends HTMLElement>(
  e: KeyboardEvent<E>
) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.stopPropagation();
    e.currentTarget.click();
  }
}

export const onActivate = (
  handler: (e: MouseEvent | KeyboardEvent) => void
) => ({
  onClick: (e: MouseEvent<HTMLElement>) => {
    handler(e);
  },
  onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
    e.stopPropagation();
    if (e.key === 'Enter' || e.key === ' ') {
      handler(e);
    }
  },
  tabIndex: 0,
});
